// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2VTnu","outerDot":"styles_outerDot__39RS2","innerDot":"styles_innerDot__3iXth","statusIndicator":"styles_statusIndicator__COtTr"};